import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { MAINTENANCE_BRANDING } from './maintenance-branding';

@Component({
  selector: 'app-maintenance-page',
  imports: [RktIconComponent],
  templateUrl: './maintenance-page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './maintenance-page.component.scss',
})
export class MaintenancePageComponent {
  readonly branding = inject(MAINTENANCE_BRANDING);
}
